import Alternatives from './Alternatives'

export default Alternatives
